import { NgModule } from '@angular/core';
import {
	CommonModule,
	DatePipe,
	TitleCasePipe,
	registerLocaleData
} from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlatpickrModule } from 'angularx-flatpickr';
import { CustomDateFormatter } from './utils/custom-date-formatter';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import localeFr from '@angular/common/locales/fr';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { HttpClientModule } from '@angular/common/http';
import { FooterComponent } from '../core/footer/footer.component';
import { NgxBootstrapModule } from './modules/ngx-bootstrap.module';
import { AccordionModule } from 'ngx-bootstrap/accordion';

import { FilterBeneficiairesByNamePipe } from './pipes/filterBeneficiaires/filter-beneficiaires-by-name.pipe';
import { FilterFormationsByDatePipe } from './pipes/filterFormations/filter-formation-by-date.pipe';
import { FilterFormationBySkillPipe } from './pipes/filterFormations/filter-formation-by-skill.pipe';
import { FilterFormationBySpecialityPipe } from './pipes/filterFormations/filter-formation-by-speciality.pipe';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { JwtModule } from '@auth0/angular-jwt';
import { LoadingComponent } from './components/loading/loading.component';

import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { ExportPdfUtils } from './utils/export-pdf-utils';
import { FilterMissionPlaceBySpecialityPipe } from './pipes/filter-mission-place/filter-mission-place-by-speciality.pipe';
import { MinutesToTimePipe } from './pipes/timeConverters/minutes-to-time.pipe';
import { DateUtils } from './utils/date-utils';
import { FilterUsersByEmployeeNamePipe } from './pipes/filterEmployee/filter-employees-by-name/filter-employees-by-name.pipe';
import { FilterSpecialitesByNamePipe } from './pipes/filter-specialites-by-name/filter-specialites-by-name.pipe';
import { FilterMissionsByDatePipe } from './pipes/filter-missions-by-date/filter-missions-by-date.pipe';
import { RecurringEventPickerComponent } from './components/recurring-event-picker/recurring-event-picker.component';
import { ToastComponent } from './components/toast/toast.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NgxEchartsModule } from 'ngx-echarts';
import { NoDataAvailableComponent } from './components/no-data-available/no-data-available.component';
import { ValidInputComponent } from './components/valid-input/valid-input.component';

//ngx
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { PaginationModule } from 'ngx-bootstrap/pagination';

import { OrderByPipe } from './pipes/order-by/order-by.pipe';
import { FilterFormationByAllFieldsPipe } from './pipes/filterFormations/filter-formation-by-all-fields.pipe';
import { FilterEmployeeByAllFieldsPipe } from './pipes/filterEmployee/filter-employee-by-all-fields/filter-employee-by-all-fields.pipe';
import { FilterUserByProfilePipe } from './pipes/filterUsers/filter-user-by-profile/filter-user-by-profile.pipe';
import { FilterVehiculeByAllFieldsPipe } from './pipes/filterVehicules/filter-vehicule-by-all-fields/filter-vehicule-by-all-fields.pipe';
import { FilterVehiculeByTravelledDistanceBetweenPipe } from './pipes/filterVehicules/filter-vehicule-by-travelled-distance-between/filter-vehicule-by-travelled-distance-between.pipe';
import { FilterVehiculeByMileageBetweenPipe } from './pipes/filterVehicules/filter-vehicule-by-mileage-between/filter-vehicule-by-mileage-between.pipe';
import { FilterVehiculeByStatusPipe } from './pipes/filterVehicules/filter-vehicule-by-status/filter-vehicule-by-status.pipe';
import { PaginatePipe } from 'ngx-pagination';
import { WeekSelectorComponent } from './components/week-selector/week-selector.component';
import { DaySelectorComponent } from './components/day-selector/day-selector.component';

import { MobileNavbarComponent } from '../core/navbar/mobile-navbar/mobile-navbar.component';
import { FilterMissionTypeByTypePipe } from './pipes/filterMissionTypeByType/filter-mission-type-by-type.pipe';
import { OrderByPipeNumber } from './pipes/order-by/order-by-number';
import { OrderByReportPipe } from './pipes/order-by/order-by-report.pipe';
import { StringUtils } from './utils/string-utils';
import { ResolveConflictModalComponent } from './components/resolve-conflict-modal/resolve-conflict-modal.component';
import { FilterMissionPlaceBySpecialtiesPipe } from './pipes/filter-mission-place/filter-mission-place-by-specialties/filter-mission-place-by-specialties.pipe';
import { FilterMissionPlaceByAllFieldsPipe } from './pipes/filter-mission-place/filter-mission-place-by-all-fields.pipe';
import { ConvertStateToStringPipe } from './pipes/convert-state-to-string.pipe';
import { SidebarComponent } from '../core/navbar/sidebar/sidebar.component';
import { TopbarComponent } from '../core/navbar/topbar/topbar.component';
import { NotificationManagerComponent } from '../core/navbar/notification-manager/notification-manager.component';
import { MessagingNotificationManagerComponent } from '../core/navbar/messaging-notification-manager/messaging-notification-manager.component';
import { FilterListViewByIdentityPipe } from './pipes/filter-list-view-by-identity/filter-list-view-by-identity.pipe';
import { FilterConversationBySenderIdentityPipe } from './pipes/filter-conversation-by-sender-identity/filter-conversation-by-sender-identity.pipe';
import { SortByMissionDatePipe } from './pipes/order-by/sort-by-mission-date.pipe';
import { FilterUserByLoginOrNameOrProfilePipe } from './pipes/filterUsers/filter-user-by-login-or-name-or-role/filter-user-by-login-or-name-or-role.pipe';
import { FilterTauxReconnaissanceByNamePipe } from './pipes/filter-tauxReconnaissance-by-name/filter-tauxReconnaissance-by-name.pipe';
import { FilterNiveauEtudeByNamePipe } from './pipes/filter-niveauEtude-by-name/filter-niveauEtude-by-name.pipe';
import { FilterNiveauQualificationByNamePipe } from './pipes/filter-niveauQualification-by-name/filter-niveauQualification-by-name.pipe';
import { FilterTypeStructureByNamePipe } from './pipes/filter-typeStructure-by-name/filter-typeStructure-by-name.pipe';
import { FilterModaliteReunionByNamePipe } from './pipes/filter-modaliteReunion-by-name/filter-modaliteReunion-by-name.pipe';
import { FilterOrigineDemandeByNamePipe } from './pipes/filter-origineDemande-by-name/filter-origineDemande-by-name.pipe';
import { FilterObjectifProByNamePipe } from './pipes/filter-objectifPro-by-name/filter-objectifPro-by-name.pipe';
import { FilterAmenagementByNamePipe } from './pipes/filter-amenagement-by-name/filter-amenagement-by-name.pipe';
import { FilterNotificationEmailByTitlePipe } from './pipes/filter-notificationEmail-by-title/filter-notificationEmail-by-title.pipe';
import { FilterEmployeeByExpertisesPipe } from './pipes/filterEmployee/filter-employee-by-expertises/filter-employee-by-expertises.pipe';
import { FilterExpertiseByNamePipe } from './pipes/filter-expertise-by-name/filter-expertise-by-name.pipe';
import { FilterSituationByNamePipe } from './pipes/filter-situation-by-name/filter-situation-by-name.pipe';
import { FilterPrestationByTypePipe } from './pipes/filterPrestation/filter-prestation-by-type/filter-prestation-by-type.pipe';
import { FilterTypeEntretienByNamePipe } from './pipes/filter-typeEntretien-by-name/filter-typeEntretien-by-name.pipe';
import { SortBySuiviPrestationDatePipe } from './pipes/order-by/sort-by-suiviPrestation-date.pipe';
import { FilterTacheByNamePipe } from './pipes/filter-tache-by-name/filter-tache-by-name.pipe';
import { FilterTypeFormationByNamePipe } from './pipes/filter-typeFormation-by-name/filter-typeFormation-by-name.pipe';
import { FilterDepartementByNamePipe } from './pipes/filter-departement-by-name/filter-departement-by-name.pipe';
import { FilterRegionByNamePipe } from './pipes/filter-region-by-name/filter-region-by-name.pipe';
import { FilterServiceByNamePipe } from './pipes/filter-service-by-name/filter-service-by-name.pipe';
import { FilterCanalCommunicationByNamePipe } from './pipes/filter-canalCommunication-by-name/filter-canalCommunication-by-name.pipe';
import { FilterTypeHandicapByNamePipe } from './pipes/filter-typeHandicap-by-name/filter-typeHandicap-by-name.pipe';
import { FilterStatutProfessionnelByNamePipe } from './pipes/filter-statutProfessionnel-by-name/filter-statutProfessionnel-by-name.pipe';
import { FilterEligibiliteBeneficiaireByNamePipe } from './pipes/filter-eligibiliteBeneficiaire-by-name/filter-eligibiliteBeneficiaire-by-name.pipe';
import { FilterTypeDocumentByNamePipe } from './pipes/filter-typeDocument-by-name/filter-typeDocument-by-name.pipe';
import { FilterSituationFamilialeByNamePipe } from './pipes/filter-situationFamiliale-by-name/filter-situationFamiliale-by-name.pipe';
import { FilterTypeEntrepriseByNamePipe } from './pipes/filter-typeEntreprise-by-name/filter-typeEntreprise-by-name.pipe';
import { FilterBeneficiaireByNamePipe } from './pipes/filter-beneficiaire-by-name/filter-beneficiaire-by-name.pipe';
import { FilterEmployeeByNamePipe } from './pipes/filter-employee-by-name/filter-employee-by-name.pipe';
import { FilterUserByNamePipe } from './pipes/filter-user-by-name/filter-user-by-name.pipe';
import { FilterPrescripteurByNamePipe } from './pipes/filter-prescripteur-by-name/filter-prescripteur-by-name.pipe';
import { FilterPrestationPipe } from './pipes/filter-prestation/filter-prestation.pipe';
import { FilterBonCommandeByNumeroPipe } from './pipes/filter-bonCommande-by-numero/filter-bonCommande-by-numero.pipe';

export function tokenGetter() {
	return localStorage.getItem('JWT_TOKEN');
}
registerLocaleData(localeFr);
@NgModule({
	declarations: [
		FooterComponent,
		FilterBeneficiairesByNamePipe,
		FilterPrestationPipe,
		FilterFormationsByDatePipe,
		FilterFormationBySkillPipe,
		FilterFormationBySpecialityPipe,
		LoadingComponent,
		FilterMissionPlaceBySpecialityPipe,
		MinutesToTimePipe,
		FilterUsersByEmployeeNamePipe,
		FilterSpecialitesByNamePipe,
		FilterTauxReconnaissanceByNamePipe,
		FilterNiveauEtudeByNamePipe,
		FilterNiveauQualificationByNamePipe,
		FilterTypeStructureByNamePipe,
		FilterTypeEntrepriseByNamePipe,
		FilterTypeEntretienByNamePipe,
		FilterTypeFormationByNamePipe,
		FilterTypeDocumentByNamePipe,
		FilterModaliteReunionByNamePipe,
		FilterOrigineDemandeByNamePipe,
		FilterObjectifProByNamePipe,
		FilterAmenagementByNamePipe,
		FilterStatutProfessionnelByNamePipe,
		FilterEligibiliteBeneficiaireByNamePipe,
		FilterCanalCommunicationByNamePipe,
		FilterDepartementByNamePipe,
		FilterRegionByNamePipe,
		FilterServiceByNamePipe,
		FilterTacheByNamePipe,
		FilterSituationByNamePipe,
		FilterExpertiseByNamePipe,
		FilterBeneficiaireByNamePipe,
		FilterBonCommandeByNumeroPipe,
		FilterEmployeeByNamePipe,
		FilterPrescripteurByNamePipe,
		FilterUserByNamePipe,
		FilterSituationFamilialeByNamePipe,
		FilterTypeHandicapByNamePipe,
		FilterNotificationEmailByTitlePipe,
		FilterMissionsByDatePipe,
		RecurringEventPickerComponent,
		ToastComponent,
		NoDataAvailableComponent,
		ValidInputComponent,
		OrderByPipe,
		OrderByPipeNumber,
		OrderByReportPipe,
		FilterFormationByAllFieldsPipe,
		FilterEmployeeByAllFieldsPipe,
		FilterEmployeeByExpertisesPipe,
		FilterPrestationByTypePipe,
		FilterMissionPlaceByAllFieldsPipe,
		FilterMissionPlaceBySpecialtiesPipe,
		FilterUserByLoginOrNameOrProfilePipe,
		FilterUserByProfilePipe,
		FilterVehiculeByAllFieldsPipe,
		FilterVehiculeByTravelledDistanceBetweenPipe,
		FilterVehiculeByMileageBetweenPipe,
		FilterVehiculeByStatusPipe,
		WeekSelectorComponent,
		DaySelectorComponent,
		MobileNavbarComponent,
		FilterMissionTypeByTypePipe,
		ResolveConflictModalComponent,
		ConvertStateToStringPipe,
		SidebarComponent,
		TopbarComponent,
		NotificationManagerComponent,
		MessagingNotificationManagerComponent,
		FilterListViewByIdentityPipe,
		FilterConversationBySenderIdentityPipe,
		SortByMissionDatePipe,
		SortBySuiviPrestationDatePipe,
	],
	imports: [
		HttpClientModule,
		CommonModule,
		RouterModule,
		NgxBootstrapModule,
		FormsModule,
		FlatpickrModule.forRoot(),
		ReactiveFormsModule,
		CalendarModule.forRoot({
			provide: DateAdapter,
			useFactory: adapterFactory
		}),

		JwtModule.forRoot({
			config: {
				tokenGetter
				// allowedDomains: ['example.com'],
				// disallowedRoutes: ['http://example.com/examplebadroute/'],
			}
		}),
		AccordionModule.forRoot(),
		BsDatepickerModule.forRoot(),
		TimepickerModule.forRoot(),
		LeafletModule,
		// NgbModule,
		BrowserAnimationsModule, // required animations module for toasts
		ToastrModule.forRoot({
			positionClass: 'toast-bottom-right',
			preventDuplicates: true,
			timeOut: 8000
		}), // ToastrModule added
		NgxEchartsModule.forRoot({
			echarts: () => import('echarts')
		}),
		BsDropdownModule.forRoot(),
		PaginationModule.forRoot()
	],
	exports: [
		RouterModule,
		CommonModule,
		NgxBootstrapModule,
		FormsModule,
		ReactiveFormsModule,
		FooterComponent,
		FilterBeneficiairesByNamePipe,
		FilterPrestationPipe,
		FilterFormationsByDatePipe,
		FilterFormationBySkillPipe,
		FilterFormationBySpecialityPipe,
		AccordionModule,
		BsDatepickerModule,
		TimepickerModule,
		LoadingComponent,
		LeafletModule,
		FilterMissionPlaceBySpecialityPipe,
		MinutesToTimePipe,
		CalendarModule,
		FilterUsersByEmployeeNamePipe,
		FilterSpecialitesByNamePipe,
		FilterTauxReconnaissanceByNamePipe,
		FilterNiveauEtudeByNamePipe,
		FilterNiveauQualificationByNamePipe,
		FilterTypeStructureByNamePipe,
		FilterTypeEntrepriseByNamePipe,
		FilterTypeEntretienByNamePipe,
		FilterTypeFormationByNamePipe,
		FilterTypeDocumentByNamePipe,
		FilterModaliteReunionByNamePipe,
		FilterOrigineDemandeByNamePipe,
		FilterObjectifProByNamePipe,
		FilterAmenagementByNamePipe,
		FilterStatutProfessionnelByNamePipe,
		FilterEligibiliteBeneficiaireByNamePipe,
		FilterCanalCommunicationByNamePipe,
		FilterDepartementByNamePipe,
		FilterRegionByNamePipe,
		FilterServiceByNamePipe,
		FilterTacheByNamePipe,
		FilterSituationByNamePipe,
		FilterPrestationByTypePipe,
		FilterExpertiseByNamePipe,
		FilterBeneficiaireByNamePipe,
		FilterBonCommandeByNumeroPipe,
		FilterEmployeeByNamePipe,
		FilterPrescripteurByNamePipe,
		FilterUserByNamePipe,
		FilterSituationFamilialeByNamePipe,
		FilterTypeHandicapByNamePipe,
		FilterNotificationEmailByTitlePipe,
		FilterMissionsByDatePipe,
		RecurringEventPickerComponent,
		NgxEchartsModule,
		NoDataAvailableComponent,
		ValidInputComponent,
		OrderByPipe,
		OrderByPipeNumber,
		OrderByReportPipe,
		TypeaheadModule,
		FilterFormationByAllFieldsPipe,
		FilterEmployeeByAllFieldsPipe,
		FilterEmployeeByExpertisesPipe,
		FilterMissionPlaceByAllFieldsPipe,
		FilterMissionPlaceBySpecialtiesPipe,
		FilterUserByLoginOrNameOrProfilePipe,
		FilterUserByProfilePipe,
		FilterVehiculeByAllFieldsPipe,
		FilterVehiculeByTravelledDistanceBetweenPipe,
		FilterVehiculeByMileageBetweenPipe,
		FilterVehiculeByStatusPipe,
		WeekSelectorComponent,
		DaySelectorComponent,
		FilterMissionTypeByTypePipe,
		ResolveConflictModalComponent,
		ConvertStateToStringPipe,
		SidebarComponent,
		TopbarComponent,
		MobileNavbarComponent,
		NotificationManagerComponent,
		MessagingNotificationManagerComponent,
		FilterListViewByIdentityPipe,
		FilterConversationBySenderIdentityPipe,
		SortByMissionDatePipe,
		SortBySuiviPrestationDatePipe,
	],
	providers: [
		DatePipe,
		TitleCasePipe,
		CustomDateFormatter,
		DateUtils,
		ExportPdfUtils,
		FilterFormationByAllFieldsPipe,
		FilterFormationBySkillPipe,
		PaginatePipe,
		StringUtils,
		SortByMissionDatePipe
	]
})
export class SharedModule {}
